export const dropdown = () => {
  const vipBtn = document.querySelector('.header__link--vip');
  const dropdown = document.querySelector('.tickets-dropdown-tippy');
  const header = document.querySelector('header');

  if (!vipBtn || !dropdown || !header) return;

  // const isMobile = () => window.innerWidth <= 480;
  const isSmallDevice = () => window.innerWidth <= 1024;
  
  let closeTimer;

  const open = () => {
    clearTimeout(closeTimer);

    vipBtn.classList.add('active');
    dropdown.classList.add('active');

    dropdown.style.maxHeight = dropdown.scrollHeight + 'px';
  };

  const close = () => {
    vipBtn.classList.remove('active');
    dropdown.classList.remove('active');

    dropdown.style.maxHeight = '0px';
  };

  const delayClose = () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, 80);
  };

  const hoverZones = [vipBtn, dropdown, header];

  hoverZones.forEach(el => {
    el.addEventListener('mouseenter', () => {
      if (isSmallDevice()) return;
      if (el !== vipBtn && !dropdown.classList.contains('active')) return;
      open();
    });

    el.addEventListener('mouseleave', () => {
      if (isSmallDevice()) return;
      delayClose();
    });
  });

  vipBtn.addEventListener('click', e => {
    if (!isSmallDevice()) return;
    e.preventDefault();

    dropdown.classList.contains('active') ? close() : open();
  });

  // dropdown.addEventListener('click', e => {
  //   e.stopPropagation();
  // });

  document.addEventListener('click', e => {
    if (!isSmallDevice()) return;
    if (vipBtn.contains(e.target) || dropdown.contains(e.target)) return;
    close();
  });
};
